const compareAsc = require('date-fns/compareAsc')
const parseISO = require('date-fns/parseISO')

/**
 * Utilities
 */

// function createCityWorkshop(ws) {
//   return { days: 2, host: false, showWorkshop: true, ...ws }
// }

function createRemoteWorkshop(ws) {
  if (!ws.remoteTimezone) {
    throw new Error('Remote Workshops Must Have A Timezone')
  }
  return { ...(!ws.minutes && { days: 1 }), showWorkshop: true, ...ws, host: false }
}

/**
 * Workshops
 */

// host: string or false
// address: an array of address lines. Also this determines Google Maps marker
// showWorkshop: will this workshop appear in the list in production

module.exports = [
  // EXAMPLE 1-Hour Free Course
  // createRemoteWorkshop({
  //   id: '2023-03-16-pacific',
  //   startDate: '2023-03-16',
  //   startTime: '10:00 AM',
  //   endTime: '11:00 AM',
  //   title: 'React Reducers',
  //   subTitle: 'Free Workshop on State Reducers',
  //   contentTemplate: 'free-reducers',
  //   minutes: 60,
  //   convertKitFormId: '2090763',
  //   remoteTimezone: 'US Pacific Time',
  //   instructors: ['chance-strickland'],
  // }),

  // createRemoteWorkshop({
  //   id: '2023-10-04-pacific',
  //   startDate: '2023-10-04',
  //   startTime: '8:00 AM',
  //   endTime: '3:00 PM',
  //   title: 'React Composition Patterns',
  //   subTitle: 'Advanced Topics',
  //   contentTemplate: 'react-advanced',
  //   remoteTimezone: 'US Pacific Time',
  //   instructors: ['brad-westfall'],
  // }),

  createRemoteWorkshop({
    id: '2023-01-30-pacific',
    startDate: '2023-01-30',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'Thinking in React',
    subTitle: 'React Fundamentals with Hooks',
    companion: 'React App Development',
    contentTemplate: 'react-core-first-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
  createRemoteWorkshop({
    id: '2023-01-31-pacific',
    startDate: '2023-01-31',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'React App Development',
    subTitle: 'Prerequisite is "Thinking in React"',
    companion: 'Thinking in React',
    contentTemplate: 'react-core-second-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
  createRemoteWorkshop({
    id: '2023-02-27-pacific',
    startDate: '2023-02-27',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'Thinking in React',
    subTitle: 'React Fundamentals with Hooks',
    companion: 'React App Development',
    contentTemplate: 'react-core-first-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
  createRemoteWorkshop({
    id: '2023-02-28-pacific',
    startDate: '2023-02-28',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'React App Development',
    subTitle: 'Prerequisite is "Thinking in React"',
    companion: 'Thinking in React',
    contentTemplate: 'react-core-second-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
  createRemoteWorkshop({
    id: '2023-03-30-pacific',
    startDate: '2023-03-30',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'Thinking in React',
    subTitle: 'React Fundamentals with Hooks',
    companion: 'React App Development',
    contentTemplate: 'react-core-first-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
  createRemoteWorkshop({
    id: '2023-03-31-pacific',
    startDate: '2023-03-31',
    startTime: '8:00 AM',
    endTime: '3:00 PM',
    title: 'React App Development',
    subTitle: 'Prerequisite is "Thinking in React"',
    companion: 'Thinking in React',
    contentTemplate: 'react-core-second-day',
    remoteTimezone: 'US Pacific Time',
    instructors: ['brad-westfall'],
  }),
]
  .sort(byStartDateAsc)
  .filter((w) => {
    return process.env.GATSBY_ACTIVE_ENV === 'production' ? w.showWorkshop : true
  })

function byStartDateAsc(a, b) {
  return compareAsc(parseISO(a.startDate), parseISO(b.startDate))
}
